import { Routes } from '@angular/router';
import { AppLayout } from '@/app/layout/components/app.layout';
import { AuthLayout } from '@/app/layout/components/app.authlayout';
import { AuthGuard } from './app/pages/service/auth/authguard.service';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        children: [
            {
                path: '',
                loadChildren: () => import('@/app/pages/pages.routes'),
                canActivate: [AuthGuard]
            },
        ]
    },
    {
        path: 'auth',
        component: AuthLayout,
        loadChildren: () => import('@/app/pages/auth/auth.routes')
    },
    { path: '**', redirectTo: '/' }
];
